__turbopack_context__.v({
  "banned": "piGH7G_banned",
  "container": "piGH7G_container",
  "error": "piGH7G_error",
  "errorTitle": "piGH7G_errorTitle",
  "image": "piGH7G_image",
  "name": "piGH7G_name",
  "unofficial": "piGH7G_unofficial",
});
